import React from 'react';

import Skeleton from 'react-loading-skeleton';

export const OffersCardV2Skeleton = () => {
  const skeletons = new Array(8)
    .fill(true)
    .map((_, index) => (
      <Skeleton
        key={index}
        height={'100%'}
        width={'100%'}
        style={{ borderRadius: '0.5rem', gridRow: 1 }}
      />
    ));

  return <>{skeletons}</>;
};
